const OPERATOR_STATISTICS = {
  OPERATOR_STATS_HEADER_TITLE: 'Operators statistics',
  OPERATOR_STATS_HEADER_DESC: `You can get operator's working time details(first and last online) and number of operator's conversations in different types (accepted,ended and ...) with choosing time period and get the export`,
  OPERATOR_STATS_MAIN_TITLE: 'Operators working time',
  OPERATOR_STATS_OPERATOR_STATS_TITLE: 'Conversations statistics',
  OPERATOR_STATS_ACCEPTED_CONVS: 'Accepted conversations : ',
  OPERATOR_STATS_FIRST_ONLINE: 'First online : ',
  OPERATOR_STATS_LAST_ONLINE: 'Last online : ',
  OPERATOR_STATS_ENDED_CONVS: 'Ended conversations : ',
  OPERATOR_STATS_CONV_PREFIX: 'Conversations',
  OPERATOR_STATS_ACTIVE_TIME: 'Active time',
  OPERATOR_STATS_CONVS_STATS: 'Conversations statistics',
  OPERATOR_STATS_TOTAL_HOUR_LABEL: `Operator's total online time`,
  OPERATOR_STATS_TOTAL_HOUR_PREFIX: 'Hours',
  OPERATOR_STATS_CHART_TAB_CONVS_STATS: 'Conversations statistics',
  OPERATOR_STATS_CHART_TAB_ACTIVE_TIME: 'Active time',
  OPERATOR_STATS_CHART_LEGEND_ACCEPTED_CONVS: 'Accepted conversation : ',
  OPERATOR_STATS_CHART_LEGEND_ENDED_CONVS: 'Ended conversations : ',
  OPERATOR_STATS_CHART_LEGEND_UNANSWERED_CONVS: 'Unanswered conversations : ',
  OPERATOR_STATS_CHART_LEGEND_DENIED_CONVS: 'Denied conversations : ',
  OPERATOR_STATS_DOWNLOAD_BTN_TEXT: 'Download',
};

export default OPERATOR_STATISTICS;
